import { TriStateToggle, TriStateToggleProps } from './triStateToggle.tsx';


interface Props extends Omit<TriStateToggleProps, 'selection' | 'onSelectionChange'> {
    selection: boolean;
    onSelectionChange?: (selection: boolean) => void;
}

export function ToggleButton(options: Props) {
    const { selection, onSelectionChange, ...rest } = options;

    function handleSelectChange(selection: boolean | null) {
        onSelectionChange?.(selection ?? false);
    }

    return (
        <TriStateToggle
            selection={selection}
            onSelectionChange={handleSelectChange}
            allowNull={false}
            {...rest}
        />
    );
}
